export enum ConstructionStatus {
  PreNTP = 'PreNTP',
  IncentiveAllocation = 'IncentiveAllocation',
  IXCostApproved = 'IXCostApproved',
  NTP = 'NTP',
  ConstructionStart = 'ConstructionStart',
  MechanicallyComplete = 'MechanicallyComplete',
  ConstructionComplete = 'ConstructionComplete',
  FinalComplete = 'FinalComplete',
}
